import React, { PropTypes } from 'react';
import styled from 'styled-components';

import { NitroIcon, NitroText } from 'nitro-components';

import { media } from "../../../../utils/style-utils";
import ButtonIcognito from '../../../../components/common/ButtonIcognito';

const Card = styled(ButtonIcognito)`
  height: 100%;
  text-align: center;
  width: 100%;
`;

const CardMetric = styled.div`
  color: ${props => props.theme.color.base1};
  font-size: 55px;
  font-weight: normal;
  line-height: 70px;
  margin: 0 auto;
  text-align: center;

  ${media.mobileTablet`
    margin: 10px 0;
  `}
`;

const CardDescription = styled.div`
  color: ${props => props.theme.color.negative};
  font-size: ${props => props.theme.size[1]};
  font-weight: bold;
  margin: 30px auto;
`;

const CardDescriptionLabel = styled.span`
  display: inline-block;
  margin-left: .5em;
`;

const CardMetricUtilisation = ({
  Description,
  Icon,
  Variant,
  onClick,
  UtilisationPerc,
}) => {
  const label = `${Math.round(UtilisationPerc)}%`;
  const message = '';

  return (
    <Card onClick={onClick}>
      <CardMetric>
        {label}
      </CardMetric>
      <CardDescription>
        {Icon && (
          <NitroIcon
            name={Icon}
            size={18}
            variant={Variant}
          />
        )}
        {message && (
          <CardDescriptionLabel>
            {message}
          </CardDescriptionLabel>
        )}
      </CardDescription>
      {Description && (
        <NitroText
          bold
          size={4}
          variant="base3"
        >
          {Description}
        </NitroText>
      )}
    </Card>
  );
};

CardMetricUtilisation.propTypes = {
  Description: PropTypes.string,
  Icon: PropTypes.string,
  onClick: PropTypes.func,
  Variant: PropTypes.string,
  UtilisationPerc: PropTypes.number,
};

export default CardMetricUtilisation;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileTabs/CardMetricUtilisation.js